import {LayoutAbbreviation} from "../../constants";
import {iIncludes} from "../../../../../misc/utils";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {Shower} from "../../parts/shower";
import {Vanity} from "../../parts/vanity";
import ExternallWall from "./externallWall";

export default class WallExR extends ExternallWall {

  constructor(isChild) {
    super(isChild);
    this.partId = "right_shower_wall";
    this.partName = "Right Shower Wall";
    this.translateId = "visualizer.bathroom.walls.right_shower_wall";
    this.wallName = "ExtrusionWallRight";
    this.shadowName = "Popout";
    this.dbName = "EX R";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new WallExR());
  }

  getShadowConditions() {
    return this.getArrayOfConditions()
  }

  getDefaultFeature() {
    const layout = this.layout;
    const layoutAbr = layout.getCurrentLayoutAbbreviation();
    const filteredFeatures = this.getAvailableFeatures();

    let hardCodedName = '';
    switch (layoutAbr) {
      case LayoutAbbreviation.Small:
        hardCodedName = 'Rafter';
        break;
      case LayoutAbbreviation.Large:
        hardCodedName = 'Sahara Autumn  Porcelain Tile';
        break;
    }
    const hardCodedDefault = filteredFeatures.find((feature) => {
      return iIncludes(feature.dbFeature.displayName, hardCodedName);
    });
    return hardCodedDefault || filteredFeatures[0];
  }

  getArrayOfConditions() {

    const wallParent = this.getParent();
    const layout = wallParent.layout;
    const layoutAbr = layout.getCurrentLayoutAbbreviation();

    const activeShowerPartId = wallParent.showerTubComboIsActive() ? ShowerTubCombo.id : Shower.id;
    const showerSize = wallParent.layout.parts[activeShowerPartId].showerSize();

    const conditions = [{
      propName: 'ShowerSize',
      propValue: showerSize
    }];

    if (layoutAbr === LayoutAbbreviation.Small) {
      let counterTopSize = layout.parts[Vanity.id].counterTopSize();
      conditions.push({
        propName: 'CountertopSize',
        propValue: counterTopSize
      });
    }

    return conditions;
  }
}
